// Worthify i18n — EN locale. Keys must mirror locales/en.js;
// missing keys fall back to English in useTranslation.
export const en = {
    // Header
    tagline: "Is it really worth it?",
    
    // Main heading
    mainHeading: "Know The True Value!",
    heroSubtext: "Check the real risk before you buy. See what it could cost you, and whether it’s worth it.",
    heroLine1: "Check the real risk before you buy.",
    heroLine2: "See what it could cost you, and whether it’s worth it.",
    heroLine3: "",
    
    // Input placeholders
    registrationPlaceholder: " ",
    pricePlaceholder: " ",
    priceHelperText: "Enter asking price (optional)",
    listingUrlPlaceholder: "Enter car listing URL (optional)",
    vinPlaceholder: "Enter VIN (optional)",
    vinHelperText: "e.g. WAUZZZ4L1BD123456",
    vinInvalid: "Invalid VIN format (must be 17 characters)",
    vinTooltip: "",
    vinPreviewLoading: "Decoding VIN…",
    vinPreviewDetected: "Detected",
    vinPreviewUnknown: "Couldn't decode this VIN — analysis will still work",
    regHelperText: "Enter a UK registration",
    ctaHelperText: "Reveal hidden issues, likely repair costs, and your negotiation position.",
    
    // Buttons
    analyzeButton: "Check now — Free",
    checkingVehicle: "Checking vehicle...",
    trustText: "No sign-in needed • Real DVSA + DVLA data • 🛡 More Than HPI Check • Instant verdict",
    downloadButton: "Download full report (only £1)",
    generatingPdf: "Generating PDF...",
    newSearch: "← New Search",
    
    // Error messages
    errorEmptyRegistration: "Please enter a vehicle registration",
    errorVehicleNotFound: "Vehicle not found. Please check the registration number.",
    errorServiceUnavailable: "Service unavailable, please try again.",
    errorReportFailed: "Failed to generate report. Please try again.",
    
    // Results - Risk level
    riskLevel: "Risk Level",
    tickerFailedMots: "FAILED MOTS",
    tickerMiles: "MILES",
    tickerDangerous: "DANGEROUS",
    verdictWorthBuying: "Looks like a good deal",
    verdictBeCareful: "Be cautious",
    verdictAvoid: "Avoid this car",
    verdictExplanationLow: "No major risk patterns detected. The vehicle history looks consistent, and there are no clear signs of costly issues. Still, always inspect the car properly before buying.",
    verdictShortExplanationLow: "History looks clean. Still inspect before you pay.",
    verdictShortExplanationMedium: "Known issues in the history. Move carefully at the right price.",
    verdictShortExplanationHigh: "Significant risks ahead. Budget for repairs — or walk away.",
    verdictShortExplanationScam: "Price is suspiciously low. Treat as a high-risk buy.",
    verdictExplanationMedium: "This car is not risk-free. There are known issues and patterns that could lead to additional costs over time. It may still be worth considering, but only at the right price and with awareness of the risks.",
    verdictExplanationHigh: "This car shows multiple warning signs that often lead to ongoing costs. While it may seem acceptable at first, the history suggests you are likely to face repairs after purchase. Unless the price clearly reflects these risks, this is not a smart buy.",
    verdictExplanationScam: "This car shows multiple warning signs that often lead to ongoing costs. While it may seem acceptable at first, the history suggests you are likely to face repairs after purchase. Unless the price clearly reflects these risks, this is not a smart buy.",
    verdictSubtextLow: "No major risk patterns detected. The vehicle history looks consistent, and there are no clear signs of costly issues. Still, always inspect the car properly before buying.",
    verdictSubtextMedium: "This car is not risk-free. There are known issues and patterns that could lead to additional costs over time. It may still be worth considering, but only at the right price and with awareness of the risks.",
    verdictSubtextHigh: "This car shows multiple warning signs that often lead to ongoing costs. While it may seem acceptable at first, the history suggests you are likely to face repairs after purchase. Unless the price clearly reflects these risks, this is not a smart buy.",
    verdictSubtextScam: "This car shows multiple warning signs that often lead to ongoing costs. While it may seem acceptable at first, the history suggests you are likely to face repairs after purchase. Unless the price clearly reflects these risks, this is not a smart buy.",
    unlockFullReport: "UNLOCK THE FULL BUYER PROTECTION REPORT — ONLY £1",
    verdictIncludesLine1: "Clear risk explanation, likely costs, negotiation leverage and hidden warning signs",
    verdictIncludesLine2: "No account needed • Instant access • Built for real buyers",
    verdictClarityLine: "Access is for this session only",
    verdictAvoidMistakes: "Know what could cost you before the seller gets paid",
    verdictTrustedBy: "Trusted by UK car buyers",
    verdictSecureLine: "Secure payment • Real DVSA history • Plain-English guidance",
    whatYouUnlock: "See the full picture before you buy",
    unlockItem1: "Full explanation of all issues",
    unlockItem2: "Realistic repair cost ranges",
    unlockItem3: "Clear buying recommendation",
    unlockItem4: "Negotiation guidance based on evidence",
    unlockItem5: "",
    expertiseUnlockCta: "Unlock premium",
    verdictScamTitle: "Scam price detected",
    verdictOverpricedTitle: "Overpriced vs market",
    verdictSuspiciousTitle: "Suspiciously low price",
    verdictOverpricedSub: "Asking {subj} is {pct}% of the {median} market value — well above fair price.",
    verdictScamSub: "Asking {subj} is only {pct}% of the {median} market value — typical scam profile.",
    verdictSuspiciousSub: "Asking {subj} is only {pct}% of the {median} market value — suspiciously low.",
    unlockItemScore: "Worthify Score with full breakdown",
    unlockItemTopRisk: "Top risk summary",
    unlockItemPriceCheck: "Price scam & overpricing detection",
    unlockItemNegotiation: "Negotiation evidence (with £ targets)",
    unlockItemCrashTest: "Crash test & safety rating",
    unlockItemAccident: "Accident history check",
    unlockItemWriteOff: "Write-off & insurance check",
    unlockItemTheft: "Theft & stolen-vehicle check",
    unlockItemFinance: "Outstanding finance check",
    unlockItemImport: "Import & export history",
    unlockItemInsurance: "Insurance group",
    unlockItemUlez: "ULEZ & CAZ daily-charge verdict",
    unlockItemCo2: "CO₂ emissions & Eco score",
    unlockItemRunningCosts: "5-year running costs forecast",
    unlockItemDepreciation: "Depreciation forecast",
    unlockItemTyresBrakes: "Tyre & brake wear analysis",
    unlockItemEngineAnalysis: "Engine analysis",
    unlockItemAnomalies: "Anomaly & diagnostic flags",
    unlockItemMotHistory: "Detailed MOT history & defects",
    unlockItemFailedMots: "Failed MOT breakdown",
    unlockItemRecurring: "Recurring issue detection",
    unlockItemOwners: "Previous owners & V5C history",
    unlockItemSimilarSold: "Similar vehicles sold",
    unlockItemTaxMot: "Live DVLA tax & MOT status",
    unlockItemVin: "VIN ↔ DVLA cross-check (clone detection)",
    unlockItemEngineExpert: "Engine Expert verdict",
    unlockItemPlatformExpert: "Platform Expert verdict",
    unlockItemRiskExpert: "Risk Expert verdict",
    unlockItemPdf: "Downloadable PDF report",
    limitedOffer: "Launch price: £1",
    unlockCtaNew: "Unlock breakdown report for £1",
    poweredByLine: "One time access • Real data • Expert analysis",
    verdictHighCostWarning: "This could cost you more than the car is worth.",
    verdictBackLink: "← Back",
    paymentProcessing: "Processing payment...",
    checkingPayment: "Checking payment status...",
    paymentConfirmedTitle: "Payment confirmed!",
    paymentConfirmedSub: "Preparing your report…",
    paymentVerifyTitle: "Checking payment status…",
    paymentVerifySub: "We're confirming your payment with Stripe — this usually takes a few seconds. Please don't close this window.",
    paymentVerifySecure: "Secured by Stripe",
    pdfDownloadedToast: "✓ Report downloaded",
    paymentVerifyingBanner: "Verifying your payment now. Your PDF will start downloading as soon as payment is confirmed.",
    // ─── Launch-readiness (Feb 2026) — share, cancel, accessibility, 429 ───
    paymentCancelledTitle: "Payment cancelled",
    paymentCancelledBody: "No charge has been made. You can try again whenever you're ready.",
    errorRateLimit: "You've made too many checks in a short time. Please wait a few minutes and try again.",
    errorRateLimitPayment: "Too many payment attempts. Please wait a few minutes and try again.",
    analyzingReassurance: "Analysis usually completes in 30–60 seconds",
    shareWithMechanicCta: "Share with a mechanic",
    shareWithMechanicKicker: "Second opinion? Send this report to a trusted mechanic.",
    shareReportMessage: "Check this vehicle report from Worthify",
    shareReportCopied: "Link copied",
    shareReportCopyManual: "Copy this link:",
    preCheckoutBenefitValuation: "Market valuation",
    preCheckoutBenefitRecall: "Recall + write-off check",
    preCheckoutBenefitMot: "MOT risk analysis",
    preCheckoutBenefitShare: "PDF + share with mechanic",
    preCheckoutTickToContinue: "Tick the box to continue",
    // ─── Hero HPI badge + modal (Feb 2026 positioning) ───────────
    heroHpiBadgeText: "More Than HPI Check",
    heroHpiBadgeAria: "Learn more about More Than HPI Check",
    moreHpiModalTitle: "Why is Worthify Different?",
    moreHpiModalSubtitle: "The UK's Best Value for Money Vehicle Intelligence Platform",
    moreHpiIntroLead: "Worthify doesn't just show vehicle data — it explains it.",
    moreHpiIntroBody: "More Than HPI Check — Worthify combines trusted UK vehicle intelligence, market valuation and AI-powered analysis in one easy-to-understand report.",
    moreHpiValueKicker: "Why pay £30+?",
    moreHpiValueBody: "Worthify delivers advanced vehicle intelligence, market valuation, MOT analysis and AI-powered buying insights for just ",
    moreHpiValueBodyEnd: ".",
    moreHpiIncludedTitle: "Premium Vehicle Intelligence Included",
    hpiIncludedFinance: "Outstanding Finance Checks",
    hpiIncludedStolen: "Stolen Vehicle Checks",
    hpiIncludedWriteOff: "Insurance Write-Off (A, B, S, N)",
    hpiIncludedVin: "VIN Verification",
    hpiIncludedIdentity: "Vehicle Identity Verification",
    hpiIncludedMileage: "Mileage Anomaly Detection",
    hpiIncludedMot: "MOT History Analysis",
    hpiIncludedRisk: "Vehicle Risk Assessment",
    hpiIncludedMarket: "Market Valuation",
    hpiIncludedWorthifyValue: "Worthify Value Analysis",
    hpiIncludedPlate: "Plate Change History",
    hpiIncludedImport: "Import / Export Status",
    hpiIncludedAi: "AI-Powered Buying Insights",
    hpiIncludedPdf: "PDF Report Export",
    hpiIncludedShare: "Share with Mechanic",
    moreHpiNoKnowTitle: "No automotive knowledge required",
    moreHpiNoKnowBody: "Worthify translates complex vehicle data into simple explanations anyone can understand. Understand what the data means before spending your money.",
    moreHpiEveryoneTitle: "Built for everyone",
    moreHpiEveryoneBody: "Designed for everyday car buyers, first-time drivers, families, enthusiasts and experienced motorists alike. Whether you're a mechanic or buying your first car, Worthify helps you understand what the data actually means before you spend your money.",
    moreHpiMultilingualTitle: "Multilingual support",
    moreHpiMultilingualBody: "Vehicle reports and explanations are available in multiple languages, making vehicle checks more accessible for everyone in the UK.",
    moreHpiFooterTrust: "Powered by trusted UK vehicle intelligence and official vehicle data sources.",
    moreHpiFooterTagline: "Vehicle Intelligence, Not Just Vehicle History.",
    moreHpiFooterChips: "🛡 More Than HPI Check · AI Analysis · Market Valuation · Premium Insights",
    // ─── Global premium positioning (paywall + CTA areas) ────────
    premiumPositioningTagline: "More Than HPI Check",
    premiumPositioningSub: "Finance · Stolen · Write-Off · VIN · AI Insights · Market Valuation",
    // ─── Pricing transparency (3 tiers inside More-Than-HPI modal) ──
    pricingTransparencyTitle: "Simple Pricing. Complete Transparency.",
    pricingTransparencySub: "Three tiers. Pay only for the depth you need.",
    tierFreeLabel: "FREE CHECK",
    tierFreeIntro: "Get an instant recommendation before spending a penny.",
    tierFreeF1: "Worthify Buy Recommendation (Avoid · Be Cautious · Good Deal)",
    tierFreeFooter: "Know whether the vehicle deserves a closer look.",
    tierStandardLabel: "STANDARD CHECK",
    tierStandardIntro: "Unlock the complete Worthify Analysis.",
    tierStdF1: "Full Worthify Buy Score (0–100)",
    tierStdF2: "Enhanced 3-AI Consensus Insights",
    tierStdF3: "Detailed MOT Analysis & Failure Patterns",
    tierStdF4: "Vehicle Strengths & Weaknesses",
    tierStdF5: "Engine Analysis & Cluster Issues",
    tierStdF6: "Expert Views (Mechanic · Dealer · Economist)",
    tierStdF7: "Negotiation Leverage & Repair Estimates",
    tierStdF8: "Crash Test / Safety Analysis",
    tierStdF9: "Share With Mechanic",
    tierStdF10: "Worthify Market Valuation",
    tierStandardFooter: "Understand what the vehicle data actually means.",
    tierPremiumLabel: "PREMIUM CHECK",
    tierPremiumBadge: "Best value",
    tierPremiumIntro: "More Than HPI Check.",
    tierPremiumIncludes: "Everything in Standard, plus advanced vehicle intelligence:",
    tierPremF1: "Outstanding Finance Checks",
    tierPremF2: "Stolen Vehicle Checks",
    tierPremF3: "Insurance Write-Off Categories (A, B, S, N)",
    tierPremF4: "VIN Verification (deep)",
    tierPremF5: "Vehicle Identity Verification",
    tierPremF6: "Mileage Anomaly Detection",
    tierPremF7: "Vehicle Risk Assessment",
    tierPremF8: "Plate Change History",
    tierPremF9: "Import / Export Status",
    tierPremF10: "Worthify Value Analysis (premium dataset)",
    tierPremF11: "AI-Powered Buying Insights (premium model)",
    tierPremF12: "Premium PDF Report (downloadable)",
    tierPremiumFooter: "Everything you need before spending thousands on a vehicle.",
    pricingFooterLine1: "Start with a free recommendation.",
    pricingFooterLine2: "Upgrade only if you want deeper insights and premium vehicle intelligence.",
    // ─── More-Than-HPI modal v2 (3-col redesign) ────────────────────
    moreHpiHeaderTitle: "Why Worthify Is Different",
    moreHpiHeaderSub: "The UK's most advanced vehicle intelligence platform built to help you make the right decision before you buy.",
    moreHpiHeroPre: "Worthify is ",
    moreHpiHeroHighlight: "More Than HPI Check",
    moreHpiHeroPost: ".",
    moreHpiHeroBody: "We combine trusted UK data, market valuation and AI analysis to give you clear answers, simple explanations and real confidence.",
    tierBestValue: "BEST VALUE",
    tierNewPill: "NEW",
    tierFreeName: "Instant Decision Help",
    tierFreeIntro2: "Get a quick recommendation before you spend a penny.",
    tierFreeBuyRec: "Buy Recommendation",
    tierFreeBasicInfo: "Basic Vehicle Information (Make · Model · Year)",
    tierFreeMot: "MOT Status (Pass / Fail / Active)",
    tierFreeTax: "Tax Status",
    tierFreeCallout: "Perfect to know if this car is worth investigating further.",
    tierFreeFooterQ: "Should I even consider this car?",
    tierStandardName: "Understand the Decision",
    tierStandardIntro2: "Unlock the full Worthify analysis and understand the risks.",
    tierStdEverythingFree: "Everything in Free Check",
    tierStdScore: "Worthify Buy Score (0–100)",
    tierStdAiExpl: "AI Analysis & Explanations",
    tierStdMot: "Detailed MOT Insights",
    tierStdStrengths: "Vehicle Strengths & Weaknesses",
    tierStdInitialRisk: "Initial Risk Assessment",
    tierStandardCallout: "Understand why this could be a good buy or a risky one.",
    tierStandardFooterQ: "Why is this a good or bad buy?",
    tierPremiumName: "More Than HPI Check",
    tierPremiumIntro2: "Get complete vehicle intelligence, market value and risk analysis.",
    tierPremEverythingStd: "Everything in Standard Check",
    tierPremFinance: "Outstanding Finance Check",
    tierPremStolen: "Stolen Vehicle Check",
    tierPremWriteOff: "Insurance Write-Off Check",
    tierPremVin: "VIN Verification",
    tierPremIdentity: "Vehicle Identity Check",
    tierPremMileage: "Mileage Anomaly Detection",
    tierPremMotHistory: "Detailed MOT History",
    tierPremRiskAdv: "Risk Assessment (Advanced)",
    tierPremMarket: "Market Valuation",
    tierPremWorthifyValue: "Worthify Value (Premium Data)",
    tierPremAiAdv: "AI Buying Insights (Advanced)",
    tierPremNego: "Negotiation Leverage",
    tierPremPlate: "Plate Change History",
    tierPremImport: "Import / Export Check",
    tierPremPdf: "PDF Report Download",
    tierPremShare: "Share With Mechanic",
    tierPremMulti: "Multi-Language Support",
    tierPremiumCallout: "Everything you need before spending thousands on a vehicle.",
    tierPremiumFooterQ: "What risks should I know about before I buy?",
    moreHpiWhy30Title: "Why pay £30+ for a traditional vehicle report?",
    moreHpiWhy30Body: "Worthify combines advanced vehicle intelligence, market valuation and AI-powered analysis into one affordable report. No jargon. Just clear answers you can trust.",
    trustIconExplain: "Simple explanations for everyone",
    trustIconAi: "AI-powered risk assessment you can trust",
    trustIconUk: "Built for UK buyers and UK vehicles",
    trustIconData: "Trusted data from official UK sources",
    trustIconOne: "One report. Everything you need.",
    moreHpiSourcesLine: "We use trusted UK data sources including DVLA, DVSA and leading vehicle data providers.",
    // ─── Suspicious-low asking-price (Feb 2026 launch fix) ──────────
    suspiciousPriceKicker: "Price looks very suspiciously low",
    suspiciousPriceShort: "Asking £{asking} is only {pct}% of the £{market} real value — either scam or hidden damage. Walk away, or be ready for repairs.",
    suspiciousPriceCtaHint: "Tap to see Price Check →",
    overpricedKicker: "Overpriced vs value",
    overpricedShort: "Asking £{asking} is {pct}% of the £{market} real value — well above fair price.",
    overpricedCtaHint: "Tap to see Price Check →",
    priceTileAddAsking: "Add asking price",
    priceTileAddAskingSub: "Tap to enter the seller's price for an instant verdict.",
    negoSuspiciousKicker: "Asking already below market",
    negoSuspiciousTitle: "Don't negotiate down — verify first",
    negoSuspiciousCopy: "Asking £{asking} is already £{gap} below this car's market value (£{market}). Even after the £{rLo}–£{rHi} in likely repairs, a fair price sits around £{fair}. The seller is offering it for less. Find out why before paying anything.",
    negoMarketValueLabel: "Market value",
    negoFairWithRepairsLabel: "Fair with repairs",
    negoAskingLabel: "Asking",
    negoSuspiciousAsk1: "Why is the price below market? (job loss / quick sale / hidden issue?)",
    negoSuspiciousAsk2: "Request a full history check + V5C logbook + full service history before any deposit",
    negoSuspiciousAsk3: "Inspect in person — never pay via crypto / wire / gift card",
    close: "Close",
    redFlagsTitle: "Red Flags",
    noRedFlags: "No red flags detected — clean history",
    yourAskingPrice: "Your asking price",
    marketMedianShort: "Real value",
    suspiciousPrice: "Suspicious — below market",
    unlockReportCta: "Unlock full report for £1",
    pdfButtonSubtext: "Don’t rely on guesswork when real money is at stake. Get a clear breakdown of risks, costs, and what they mean for your decision.",
    pdfButtonSubtext2: "Pay once. Use it before you commit.",
    
    // Worthify Score
    verdictAvoidCar: "Avoid this car",
    verdictShortBad: "Very poor value.",
    verdictShortMedium: "Proceed with caution.",
    verdictShortGood: "Solid purchase.",
    verdictSubShortBad: "High risk vehicle.",
    verdictSubShortMedium: "Some concerns detected.",
    verdictSubShortGood: "Clean history vehicle.",
    scoreCardSubtext: "Repair costs \u00B7 Hidden issues \u00B7 Negotiation leverage",
    potentialLossTitle: "Potential loss buying this car",
    overpricedByLabel: "Overpriced by",
    totalPotentialLoss: "Total potential loss",
    totalEstimatedCost: "Total estimated cost",
    detailedPotentialCosts: "Detailed potential Risk & Cost",
    bigCostHeadline: "Expected future investment: {amount}",
    costSubtitleExplanation: "Realistic costs you should plan for over the next 12-24 months — based on confirmed defects, the engine family and the platform's typical weak spots.",
    expectedCostTitle: "Expected ownership cost (next 12–24 months)",
    expectedCostTypicalSuffix: "typical",
    expectedCostRangeSuffix: "realistic range",
    expectedCostRelativePrefix: "≈",
    expectedCostRelativeSuffix: "of vehicle value",
    expectedCostDriversTitle: "Driven by:",
    expectedCostWorstTitle: "Potential downside",
    expectedCostWorstBody: "Up to {amount}+ if a major failure occurs ({worst_drivers}).",
    expectedCostFootnote: "Based on MOT history, known engine patterns, and statistical repair data.",
    expectedCostNoData: "No high-confidence cost drivers in this car's history yet — keep an eye on the next service.",
    paywallTeaserLow: "Looks reasonable on paper. The full breakdown shows you what to verify before you commit.",
    paywallTeaserMedium: "We found things worth knowing before you pay. Get the full breakdown for £1.",
    paywallTeaserHigh: "Multiple risks ahead. See exactly what they will cost you before the seller does.",
    paywallTeaserScam: "Price looks too good to be true. See the full breakdown before you transfer a penny.",
    paywallTeaserCTA: "Unlock the full report — £1",
    expertSellerScriptNoHistory: "Hi — I'm seriously interested in the car. Worthify ran an independent valuation based on the engine family, platform reliability data and current condition, and the realistic value sits at {realValue}. To make the deal fair on both sides, I'd need the price brought down by {target}.",
    expertSellerScriptValuationOnly: "Hi — I'd like to move on this car this week. Worthify's independent valuation, based on the engine, platform and condition, puts realistic value at {realValue}. I'd be ready to pay that today.",
    whyScoreTitle: "Why this score",
    whyScoreNoHistorySub: "No MOT history yet, so the score leans heavily on engine and platform data:",
    whyScoreWithHistorySub: "Driven by these factors:",
    whyScoreFactorEngine: "Engine family risk",
    whyScoreFactorPlatform: "Model platform risk",
    whyScoreFactorHistory: "MOT history pattern",
    whyScoreFactorUsage: "Usage / mileage profile",
    whyScoreFactorSafety: "Crash-test rating",
    whyScoreNoHistoryHint: "New cars with no test history start lower because we cannot yet see how the car has actually been driven and serviced — only how this engine and platform tend to behave on average.",
    familyDeltaBetter: "Your specific {make_model} scores {pts} pts better than the average {family} we have analysed ({n} cars).",
    familyDeltaWorse: "Your specific {make_model} scores {pts} pts lower than the average {family} we have analysed ({n} cars).",
    familyDeltaSame: "Your specific {make_model} sits right at the average for the {family} family ({n} cars analysed).",
    socialProofTitle: "Pattern in this engine family",
    socialProofSubtitle: "Across {n} {family} we have analysed:",
    socialProofIssueRow: "{pct}% had {issue}",
    confidenceBadgeLabel: "Confidence",
    confidenceHigh: "HIGH",
    confidenceMedium: "MEDIUM",
    confidenceLow: "LOW",
    confidenceConsensus: "{n}-AI consensus",
    vinVerifiedLabel: "VIN verified",
    vinVerifiedSource: "NHTSA decoded",
    vinVerifiedTooltip: "Engine variant, trim and plant identified from your VIN — analysis precision boosted.",
    loadingFactPeers: "Cross-checking against {n} {family} we have already analysed",
    loadingFactPeersFew: "Building the picture for this engine family — fewer than 5 peers analysed yet",
    loadingFactMOT: "Reading {n} MOT tests on record for this car",
    loadingFactMOTNew: "Brand-new car — no MOT tests on record yet",
    loadingFactAge: "{make} {model} ({year}) — pulling typical weak spots",
    loadingFactScoring: "Running deterministic Worthify scoring — never a single AI decides alone",
    loadingFactSafety: "Looking up Euro NCAP crash-test data",
    minimalRisk: "Minimal risk",
    scoreLabel: "Worthify Score",
    accessFullAssessment: "Access full risk assessment",
    lossWarning: "You could lose {amount}",
    negotiationPowerTitle: "Your negotiation advantage",
    youCanNegotiate: "Evidence-backed reduction",
    expertScriptLabel: "Expert negotiation script",
    copyMessage: "Copy message",
    confirmedMotIssues: "confirmed MOT findings",
    expertSellerScript: "Hi — I'm genuinely interested in the car and ready to move quickly. I had the MOT history independently reviewed by Worthify and the report flags {target} of immediate, realistic repair work: {issues}. These aren't worst-case numbers — they're the actual cost of sorting what the MOT already shows. To reflect that, I'd need the price reduced by {target}.",
    expertSellerScriptClose: "If we can agree on {finalPrice}, I can sort everything today.",
    worthifyExpertsSuggest: "Worthify experts suggest negotiating",
    askingPriceLabel: "Asking price",
    realValueWorthifyLabel: "Real value (Worthify)",
    realValueGvdLabel: "Market value (DVLA registry)",
    // ── Marketing nav (H40k) ──
    navHome: "Home",
    navAbout: "About",
    navPricing: "Pricing",
    navFaq: "FAQ",
    navContact: "Contact",
    navDownloadApp: "Download app",
    downloadPageTitle: "Get the Worthify app on your phone",
    downloadPageSubtitle: "The same plain-English car checks, AI verdict and negotiation tools — now as a native app you install straight from worthify.co.uk.",
    downloadTagline: "Is it really worth it? — instant used-car risk checks.",
    downloadAndroidNote: "Install the .apk directly — no Play Store account needed.",
    downloadAndroidCta: "Download for Android",
    downloadIosNote: "Apple doesn't allow installing apps directly from a website. The iOS app is coming to the App Store — meanwhile, use worthify.co.uk in Safari.",
    downloadComingSoon: "App Store — coming soon",
    downloadInstallTitle: "How to install on Android",
    downloadStep1: "Tap “Download for Android” below to save the .apk file.",
    downloadStep2: "Open the file — Android may ask you to allow installs from this source.",
    downloadStep3: "Confirm the install and open Worthify from your home screen.",
    downloadTrustLine: "Official Worthify build · signed & safe · no tracking without consent",
    downloadBannerTitle: "Get the app",
    downloadBannerScan: "Scan to install on your phone",
    downloadBannerCta: "Or open download page →",
    realValueWorthifySub: "with current state & defects",
    scoreAdjustedBadge: "Updated with premium data",
    // Penalty-specific badge / pill labels (H40g)
    penaltyLabel_theft: "Stolen on PNC",
    penaltyLabel_finance: "Outstanding finance",
    penaltyLabel_mileage_anomaly: "Mileage anomaly",
    penaltyLabelWriteOff: "Write-off recorded",
    penaltyLabelWriteOff_A: "Cat A write-off",
    penaltyLabelWriteOff_B: "Cat B write-off",
    penaltyLabelWriteOff_S: "Cat S write-off",
    penaltyLabelWriteOff_N: "Cat N write-off",
    penaltyLabelWriteOff_D: "Cat D write-off",
    penaltyLabelWriteOff_X: "Cat X write-off",
    penaltyPillAvoid: "Avoid",
    penaltyPillCaution: "Caution",
    plainEnglishKickerAvoid: "REGISTRY VERDICT",
    plainEnglishKickerCaution: "REGISTRY VERDICT",
    simpleExplanationCardSubAvoid: "Tap to see why the score dropped",
    simpleExplanationCardSubCaution: "Tap to see the registry findings",
    anchorFreeBadge: "Independent · anchor-free",
    marketValueLabel: "Market value",
    worthifyValuationTitle: "Worthify valuation",
    worthifyExpertValuesThisCarAt: "Worthify experts value this car at",
    withCurrentStateAndDefects: "with its current state and defects",
    valuationGuidanceExplainer: "Ideally the asking price should be close to this figure. Significantly higher means you'd be overpaying. Significantly lower can be a red flag — hidden damage, category write-offs or fraud. Ask before you commit.",
    negotiationGapExplainer: "Asking price {asking}, real Worthify value {realValue}. The {gap} gap reflects the current condition of this car and should be part of your negotiation.",
    suspiciouslyCheapWarning: "Asking {asking} against a real value of {realValue} is unusually low. Cars don't sell this cheap without a reason — check for hidden damage, missing documents, outstanding finance or category write-off before you pay.",
    fairOrBelowExplainer: "Asking {asking} against a real value of {realValue} — this is fair or already below the Worthify figure. No meaningful negotiation gap from valuation alone, but you can still use the listed repair costs as leverage.",
    offTheAskingPrice: "off the asking price",
    basedOnTheseIssues: "Based on these confirmed issues",
    realisticRepairCost: "Realistic repair",
    priceAboveMarket: "Asking price above market value",
    overMarketValue: "over typical market value",
    negotiationExplainer: "This figure reflects the realistic cost of fixing what the MOT actually shows — not worst-case scenarios. Use it as your starting position with the seller.",
    useThisToLowerPrice: "Use this range to push the asking price down",
    totalRepairCostRange: "Total repair cost range",
    whatToSayToSeller: "Suggested message",
    riskFactors: "Risk Factors",
    fullAnalysisInPdf: "Full risk explanation, negotiation advice & MOT timeline in PDF report",
    pdfUpsellTitle: "See the full picture before you buy",
    pdfIncludes1: "Full explanation of all issues",
    pdfIncludes2: "Realistic repair cost ranges",
    pdfIncludes3: "Clear buying recommendation",
    pdfIncludes4: "Negotiation guidance based on evidence",
    pdfIncludes5: "",
    topResultCta: "Protect yourself",
    topResultSupportCopy: "Whatever the verdict — we have your back. Real numbers, real leverage, real protection.",
    unlockSectionHeadline: "Don’t rely on guesswork when real money is at stake. Get a clear breakdown of risks, costs, and what they mean for your decision.",
    unlockSectionCta: "Unlock full report for £1",
    resultVerdictLabel: "Verdict",
    riskOutlookLabel: "Risk outlook",
    potentialLossLabel: "Potential loss",
    decisionMoodLabel: "Decision mood",
    heroCaptionHigh: "This car looks expensive to own.",
    heroCaptionMedium: "Think twice before saying yes.",
    heroCaptionLow: "This one looks safer than most.",
    costAlertLabel: "Cost alert",
    vehicleSnapshotLabel: "Vehicle snapshot",
    priorityReviewLabel: "Priority review",
    unlockPremiumSection: "Unlock premium section",
    fullIssuesEyebrow: "All issues",
    advancedDataLabel: "Advanced data",
    pdfUnlockLabel: "PDF unlock",
    
    aiSummaryTitle: "Expert Summary",
    aiAnalysisTitle: "Expert view",
    riskExplanation: "Risk Explanation",
    positivesTitle: "What Looks Reassuring",
    negotiationInsight: "Negotiation Insight", 
    finalAdvice: "Final Advice",
    topRiskTitle: "Top Risk",
    otherRisksTitle: "Other Potential Risks",
    otherRisksSubtitle: "Typical weaknesses of this engine / platform — not confirmed on this car.",
    repairCost: "Repair cost",
    knownModelIssuesTitle: "Known Weak Spots For This Model",
    aiEstimatedValue: "Estimated Real Value",
    priceEvalTitle: "Price Assessment",
    evidenceTitle: "Evidence from MOT",
    expertNoteLabel: "Expert note",
    topIssueLabel: "Top issue on this car",
    topIssueLead: "This defect was recorded in the MOT history for this vehicle.",
    topIssueLeadRecurring: "This defect has appeared in {count} MOT tests and is still on record — it has not been resolved and is very likely to worsen.",
    notConfirmedBadge: "Not confirmed on this car",
    engineFamilyContext: "Engine family context",
    consequencesTitle: "If ignored",
    severityHigh: "HIGH RISK",
    severityMedium: "MEDIUM RISK",
    severityLow: "LOW RISK",
    engineAnalysisTitle: "Engine Analysis",
    engineIdentified: "Identified Engine",
    engineCode: "Engine Code",
    engineKnownIssues: "Known Engine Issues",
    typicalWeaknessesTitle: "Typical weaknesses of this engine",
    typicalWeaknessesDisclaimer: "These are known potential problems for THIS engine family — they can happen, but don't have to. Your car's real confirmed defects are in the MOT history below.",
    safetyRatingLabel: "Safety (crash test)",
    safetyVerdictSafe: "Strong safety — proven in crash tests",
    safetyVerdictAverage: "Average safety — adequate, not outstanding",
    safetyVerdictPoor: "Below-average safety — consider alternatives",
    safetyRatingSource: "Euro NCAP independent test",
    engineConfidence: "Confidence",
    mileageAnalysisTitle: "Mileage Analysis",
    mileageHeroTitle: "Mileage\nanalysis",
    averageYearly: "Average yearly",
    milesPerYear: "miles/year",
    mileageTrend: "Trend",
    trendStable: "Stable",
    trendHigh: "High usage",
    trendLow: "Low usage",
    trendInconsistent: "Inconsistent",
    trendRollback: "Rollback suspected",
    trendUnknown: "Unknown",
    mileageFlags: "Flags",
    flagRollback: "Mileage rollback suspected",
    flagLowUsage: "Very low usage detected",
    flagHighUsage: "High annual mileage",
    flagInconsistent: "Mileage inconsistency detected",
    aiMileageInsight: "Expert Mileage Insight",
    
    // Scam Detection
    scamWarning: "PRICE WARNING",
    scamAlertTitle: "Possible Scam Detected",
    scamAlertDesc: "This price is suspiciously low. Could indicate fraud, stolen vehicle, or hidden damage.",
    scamRiskBadge: "HIGH SCAM RISK",
    suspiciousBadge: "SUSPICIOUS PRICE",
    overpricedBadge: "OVERPRICED",
    fairPriceBadge: "FAIR PRICE",
    priceRange: "Market range",
    priceComparison: "Price vs real value",
    ofMarketValue: "of real value",
    
    // Vehicle Information
    vehicleInfo: "Vehicle Information",
    mileageLabel: "Mileage",
    mileageVsAge: "miles/year average for vehicle age",
    registration: "Registration",
    makeModel: "Make & Model",
    year: "Year",
    engine: "Engine",
    engineCode: "Engine Code",
    
    // Statistics
    totalTests: "Total Tests",
    failedTests: "Failed Tests",
    failsInLast3: "Fails in Last 3",
    dangerousDefects: "Dangerous Defects",
    recurringIssues: "Recurring Issues",
    
    // Analysis sections
    aiExpertAnalysis: "Expert Analysis",
    priceAnalysis: "Price check",
    marketMedian: "Market Median",
    typicalRange: "Typical Range",
    priceFlag: "Price Flag",
    knownIssues: "Known Issues for This Model",
    anomaliesDetected: "Anomalies Detected",
    recurringIssuesTitle: "Recurring Issues",
    motTestHistory: "MOT Test History",
    detectedIssuesTitle: "Detected Issues",
    fullIssuesTitle: "Issues",
    
    // Defect types
    advisory: "Advisory",
    major: "Major",
    dangerous: "Dangerous",
    recurring: "Recurring",
    
    // MOT Timeline
    noDefectsFound: "✓ No defects found - clean test",
    miles: "miles",
    expires: "Expires",
    appears: "Appears",
    times: "times",
    
    // Anomaly descriptions
    mileageDrop: "Odometer reading decreased between tests - potential tampering",
    coolingSystemFlags: "Cooling system issues detected in MOT history",
    chainIssueSuspected: "Potential timing chain problems (common in this engine)",
    
    // Sources
    sources: "Sources",
    link: "Link",

    // Loading overlay
    analyzingTitle: "Analyzing vehicle history...",
    loadingStep1: "Checking MOT history...",
    loadingStep2: "Detecting hidden issues...",
    loadingStep3: "Analyzing mileage patterns...",
    loadingStep4: "Identifying engine risks...",
    loadingStep5: "Estimating repair costs...",
    loadingStep6: "Cross-checking anomalies...",
    loadingIssuesDetected: "Potential issues detected...",
    loadingFinalizing: "Finalizing risk assessment...",
    aiWorking: "Experts reviewing...",
    aiDispatch: "Gathering experts...",
    aiRoleEngine: "Engine expert",
    aiRolePlatform: "Platform expert",
    aiRoleRisk: "Risk expert",
    expertConfirmBadge: "Verified by 3 experts",
    expertConfirmTitle: "Expert team confirmed",
    expertConfirmSubtitle: "3 independent experts reviewed your full report",
    expertConfirmFinalScore: "Final score",
    // ── Premium £4.99 expert reveal overlay (Session H40c) ──
    premiumExpertOverlayBadge: "Premium analysis complete",
    premiumExpertOverlayTitle: "Experts reviewed the deep data",
    premiumExpertOverlaySub: "Updating your Worthify Score from the registry findings…",
    premiumExpertOverlayScore: "Updated score",
    premiumExpertOverlayDone: "Tap anywhere to view full report",
    premiumExpertAnnaRisk: "Anna · Risk Expert",
    premiumExpertEngine: "Marcus · Engine Expert",
    premiumExpertPlatform: "Iris · Platform Expert",
    premiumFindingWriteOff: "found a write-off record",
    premiumFindingTheft: "found a theft record",
    premiumFindingMileage: "found a mileage anomaly",
    premiumFindingFinance: "found outstanding finance",
    expertConfirmVerdictRefined: "Verdict refined with full expert consensus",
    // Mobile dashboard (tiles + modals)
    looksLike: "Looks like",
    worthifyScoreLabel: "Worthify Score",
    expectedCostShortLabel: "Expected cost",
    topRiskLabel: "Top Risk",
    priceCheckLabel: "Price check",
    avgYearlyMiles: "Avg miles / yr",
    totalMilesLabel: "Total miles",
    yearlyBreakdownTitle: "Yearly breakdown",
    scamDetectionLabel: "Scam checks",
    scamSafeValue: "Clean",
    scamSafeBadge: "No red flags",
    scamFlaggedBadge: "Flagged",
    scamAllClearTitle: "No red flags detected",
    scamAllClearCopy: "MOT history and mileage look consistent.",
    scamChecklistTitle: "What we checked",
    scamCheck1: "Mileage consistency across MOT tests",
    scamCheck2: "Dangerous defect history",
    scamCheck3: "Recurring or ignored defects",
    scamCheck4: "Long MOT gaps or suspicious patterns",
    pdfReportValue: "Download",
    pdfReportLabel: "Full PDF report",
    pdfIncludesTitle: "What's inside",
    whatThisMeans: "What this means",
    noMajorRisks: "No major risks",
    noPriceEvalCopy: "Add a target price to get a price check.",
    safetyGoodCopy: "Strong crash-test performance for its era.",
    safetyOkCopy: "Average crash-test performance for its era.",
    safetyPoorCopy: "Below-average crash-test performance.",
    safetyNoDataCopy: "No Euro NCAP rating available for this model.",
    // 5-tier safety headlines + copies (one per Euro NCAP star)
    safetyHeadline5: "Excellent safety",
    safetyHeadline4: "Strong safety",
    safetyHeadline3: "Average safety",
    safetyHeadline2: "Weak safety",
    safetyHeadline1: "Poor safety",
    safetyCopy5: "Top-tier crash protection — full 5★ Euro NCAP. Among the safest cars of its era, with strong adult, child and pedestrian protection.",
    safetyCopy4: "Strong crash-test performance — 4★ Euro NCAP. A well-built safety package that holds up well in modern impact tests.",
    safetyCopy3: "Average crash protection — 3★ Euro NCAP. Acceptable for its era, but newer rivals offer noticeably better occupant and pedestrian safety.",
    safetyCopy2: "Weak crash protection — 2★ Euro NCAP. Below modern safety standards, with measurable risk in front and side impacts.",
    safetyCopy1: "Poor crash protection — 1★ Euro NCAP. Significant safety concerns in real-world impacts; consider a safer alternative if possible.",
    // Full safety breakdown — 4 Euro NCAP axes
    safetyBreakdownTitle: "Full safety breakdown",
    safetyBreakdownCopy: "How this car scores across the four Euro NCAP test areas.",
    safetyAxisAdult: "Adult occupant",
    safetyAxisChild: "Child occupant",
    safetyAxisPedestrian: "Pedestrian / VRU",
    safetyAxisAssist: "Safety assist",
    safetyBreakdownUnlockCta: "Unlock full breakdown — £4.99",
    scoreExpertsUnlockCta: "Unlock full expert analysis — £4.99",
    dangerousDefects: "dangerous defects",
    downloadingPdf: "Downloading…",
    highRiskLabel: "HIGH RISK",
    mediumRiskLabel: "MEDIUM",
    lowRiskLabel: "LOW RISK",
    unknownCause: "major failure",
    // Reference-design labels (v2 mobile dashboard)
    expectedCostShortTitle: "Expected future investment",
    costSubtitleShort: "Realistic costs you should plan for over the next 12–24 months.",
    // ExpectedCostCard hero (full-width reference design)
    expectedCostHeroTitle: "Expected\nfuture cost",
    expectedCostBottomCaption: "Estimated cost over the next 12–24 months",
    costTierLow: "Low",
    costTierModerate: "Moderate",
    costTierHigh: "High",
    costTierClean: "Looks clean",
    costDriversTitle: "What's driving these costs",
    safetyCardTitle: "Safety (Crash Test)",
    safetyTileStrong: "Strong safety – proven in crash tests",
    safetyTileAverage: "Average crash-test safety for its era",
    safetyTilePoor: "Below-average crash protection",
    safetyTileNoData: "No Euro NCAP data",
    priceScamTitle: "Price Check",
    priceFair: "Price looks fair",
    priceOverpriced: "Price looks high",
    priceSuspicious: "Price looks suspicious",
    priceSubtitleDetected: "Based on market data & history.",
    priceNoData: "No price issues detected",
    priceFairBig: "FAIR PRICE",
    priceOverpricedBig: "OVERPRICED",
    priceSuspiciousBig: "SUSPICIOUS PRICE",
    ourVerdictLabel: "Our verdict",
    averageYearly: "Average yearly",
    milesPerYear: "miles/year",
    averageYearlyMileage: "Average yearly mileage",
    mileageConsistent: "Mileage looks consistent",
    mileageAnomalyCopy: "Mileage anomaly detected",
    mileageStableBadge: "STABLE",
    mileageAnomalyBadge: "ANOMALY",
    mileageTrend: "Mileage trend",
    mileageInsightTitle: "Mileage insight",
    mileageInsightConsistent: "Mileage looks consistent with the vehicle's age and history.",
    mileageInsightAnomaly: "Mileage progression shows inconsistencies. Inspect service records carefully.",
    dangerousDefectsHeadline: "You have dangerous defects",
    dangerousDefectsFound: "dangerous defects found",
    issuesFound: "issues found",
    allClear: "All clear",
    riskSuffix: "RISK",
    detectedTimesPrefix: "Detected",
    detectedTimesSuffix: "times in MOT history",
    estimatedCost: "Estimated cost",
    whyRiskTitle: "Why is this a risk?",
    ifIgnoredTitle: "If ignored, it can lead to:",
    expertTipLabel: "Expert tip",
    expertTipBody: "Get it inspected before purchase and budget for the repair.",
    allDetectedIssues: "All detected issues",
    failedMotsLabel: "Failed MOTs",
    viewFailedTests: "View failed tests",
    recurringIssuesLabel: "Recurring Issues",
    viewIssues: "View issues",
    motHistoryLabel: "MOT History",
    viewHistory: "View history",
    motHistoryTitle: "MOT history",
    failedMotsTitle: "Failed MOT tests",
    failedOnce: "failed test",
    failedPlural: "failed tests",
    failedTestDetails: "Failed test details",
    noFailedDetails: "Detailed failure data not available for this vehicle.",
    recurringIssuesTitle: "Recurring issues",
    noRecurring: "No recurring issues found in the MOT history.",
    seenIn: "Seen in",
    testRecorded: "test recorded",
    testsRecorded: "tests recorded",
    fullTimeline: "Full timeline",
    noMotDetails: "Detailed MOT timeline not available.",
    pdfFullReportLabel: "Full Report",
    pdfUnlockTitle: "Unlock the full report",
    pdfUnlockCopy: "Get the complete breakdown, expert insights and cost analysis in PDF.",
    pdfUnlockCta: "Unlock for £4.99",
    pdfDownloadNow: "Download full report",
    dataSourcesTitle: "We check 50+ data sources",
    dataSourcesCopy: "DVLA, MOT, Insurance, Market data & more",
    navOverview: "Overview",
    navVehicle: "Vehicle",
    navSearch: "New Search",
    navReports: "Reports",
    navMore: "More",
    scoreBadgeGood: "GOOD",
    scoreBadgeOk: "AVERAGE",
    scoreBadgeBad: "POOR",
    verifiedBy3Experts: "Verified by 3 independent experts",
    whyThisScore: "Why this score?",
    scoreScaleTitle: "Score scale",
    scoreScaleExcellent: "Excellent",
    scoreScaleGood: "Good",
    scoreScaleAverage: "Average",
    scoreScalePoor: "Poor",
    scoreScaleVeryPoor: "Very poor",
    scoreDisclaimer: "Scores are based on available data and are not a guarantee of vehicle condition.",
    expertViewLabel: "Expert view",
    expectedCostModalTitle: "Expected future cost",
    expectedCostSubtitle: "Estimated cost over the next 12–24 months",
    costBreakdownTitle: "Cost breakdown",
    realisticRangeLabel: "Realistic range",
    expertInsightLabel: "Expert insight",
    expectedCostInsight: "Costs are moderate, but recurring issues increase the chance of higher repair bills.",
    // Deterministic fallback paragraphs when AI summary is empty
    expectedCostFallbackDrivers: "Typical 12–24 month exposure for this car is around £{cost}, mainly driven by {drivers}.",
    expectedCostFallbackTopRisk: "Typical 12–24 month exposure for this car is around £{cost}, with {issue} as the main concern.",
    expectedCostFallbackGeneric: "Typical 12–24 month exposure for this car is around £{cost} based on its age, mileage and known model issues.",
    expectedCostFallbackRange: "Realistic range £{lo}–£{hi}; preventive servicing now usually keeps you near the lower end.",
    useThisToNegotiate: "Use this to negotiate",
    testedIn: "Tested in",
    miles: "miles",
    looksLikeA: "Looks like a",
    verdictPrefixLow: "Looks like a",
    verdictPrefixMedium: "Proceed with",
    verdictPrefixHigh: "Better to",
    verdictMainMedium: "CAUTION",
    verdictShortGoodDeal: "GOOD DEAL",
    verdictShortBeCautious: "BE CAUTIOUS",
    verdictShortAvoid: "AVOID",
    heroFailedLabel: "FAILED",
    heroMotSingular: "MOT",
    heroMotPlural: "MOTS",
    // v3 additions
    seenInMotPrefix: "MOT-confirmed",
    aiSuggested: "AI-suggested",
    motConfirmedBadge: "MOT-confirmed",
    scoreShortGood: "Solid history — the numbers back up a confident purchase.",
    scoreShortOk: "Mixed signals — workable with negotiation, but watch the recurring issues.",
    scoreShortBad: "High risk profile — plan careful inspection before you commit.",
    totalRangeLabel: "Full range",
    pdfUnlockedLabel: "Unlocked",
    pdfDownloadTitle: "Download your full report",
    pdfDownloadCopy: "Your complete PDF report is ready.",
    unlockMoreDataLabel: "Unlock more data",
    unlockMoreDataTitle: "Unlock 15 premium analyses",
    unlockMoreDataCopy: "One-time £4.99 payment unlocks engine, negotiation, anomalies, owners, accident, finance, ULEZ, running costs, depreciation and 6 more checks + full PDF.",
    fullPdfReport: "Full PDF report",
    vehicleInformationTitle: "Vehicle information",
    vehicleSpecsTitle: "Specifications",
    vehicleMakeLabel: "Make",
    vehicleModelLabel: "Model",
    vehicleYearLabel: "Year",
    vehicleEngineLabel: "Engine",
    vehicleMileageLabel: "Mileage",
    vehicleFuelLabel: "Fuel",
    vehicleColourLabel: "Colour",
    vehicleRegDateLabel: "First registered",
    vinVerifiedLabel: "VIN verified",
    expertiseModalTitle: "Expert analysis",
    worthifyExpertName: "Worthify Expert",
    worthifyExpertRole: "Vehicle history specialist · 3-AI consensus",
    expertVerifiedBadge: "Verified",
    expertSummaryLabel: "Summary",
    engineCodeLabel: "Engine code",
    knownIssuesTitle: "Known engine issues",
    yourLeverageTitle: "Your leverage",
    // NegotiationModal — premium real-data rebuild
    suggestedReductionKicker: "Suggested reduction",
    offAskingLabel: "off asking price",
    expertLeverageTitle: "Expert leverage",
    sellerScriptTitle: "What to say to the seller",
    copyPasteReadyLabel: "Copy · paste · send",
    negoBulletTopRisk: "Top risk: {issue} — repair typically £{lo}–£{hi}.",
    negoBulletKnownIssues: "This model has {n} typical weak points — raise them at the viewing.",
    negoBulletTopDocumented: "Documented issue: {issue} — repair typically £{lo}–£{hi}.",
    negoBulletDocExposure: "Documented repair exposure: £{lo}–£{hi} based on this car's MOT history.",
    negoStartMaxLine: "Start at £{start} · max buy £{max}",
    negoBulletTotalExposure: "Total repair exposure: £{lo}–£{hi} over the next 24 months.",
    negoBulletComfortPrice: "A comfortable offer reflecting this risk sits near £{price}.",
    negoEmptyCopy: "No strong leverage points detected — this car's technical and market profile look clean. A firm but fair offer at asking price (or 2–3% below) is reasonable.",
    // Scam-low listing warning (asking < 65% of real value)
    negoScamHeader: "Scam detected",
    negoScamTitle: "Do not negotiate — walk away",
    negoScamCopy: "The asking price (£{asking}) is far below this car's real market value (£{value}). This pattern almost always signals a fake listing, stolen vehicle, undisclosed damage, or escrow scam. Do not pay any deposit, share documents or arrange transport. Report the listing and move on.",
    negoScamBullet1: "Verify the seller's identity in person before any payment",
    negoScamBullet2: "Run a DVLA / full history check on the VIN before transferring funds",
    negoScamBullet3: "Reject any request for crypto / gift card / wire transfer",
    // VIN mismatch scam variants
    negoScamVinTitle: "VIN does not match the registration — walk away",
    negoScamVinCopy: "Seller's VIN decodes to {vinMake} {vinYear}, but DVLA registration shows {dvlaMake} {dvlaYear}. This is a textbook cloned-car / VIN-swap signal. Do not pay any deposit or share documents.",
    // Score modal scam banner
    scoreScamHeader: "Scam detected",
    scoreScamPriceTitle: "Asking price far below real market value",
    scoreScamPriceCopy: "Asking price is far below this car's real market value. Almost always indicates a fake listing, stolen vehicle, or escrow scam — score forced to 25/100 (AVOID).",
    scoreScamVinTitle: "VIN does not match the registration",
    scoreScamVinCopy: "The seller's VIN decodes to a different make or year than the DVLA registration. This pattern signals a cloned car or VIN-swap scam — score forced to 25/100 (AVOID).",
    noAnomalies: "No anomalies detected in the MOT history.",
    flaggedAnomalies: "Flagged anomalies",
    lockedPremiumTitle: "Premium insight",
    lockedPremiumCopy: "Unlock this section together with the full PDF report and 14 other premium checks for £4.99.",
    premiumAnalysesTitle: "All analyses",
    moreLockedHeadline: "3 premium analyses locked",
    premiumLockedTag: "Premium · Locked",
    premiumUnlockedTag: "Premium · Unlocked",
    newSearchTitle: "New car check",
    newSearchCopy: "Start a new analysis for another registration. Current analysis stays saved.",
    currentRegLabel: "Current",
    checkNewCarCta: "Check a new car",
    cancelLabel: "Cancel",
    swipeDownHint: "Tip: swipe down to dismiss",
    registrationLabel: "Registration",
    regPlaceholder: "e.g. AB12CDE",
    vinOptionalHint: "Optional · 17 characters · improves accuracy",
    priceOptionalHint: "Optional · unlocks price check",
    newSearchPaymentTitle: "New analysis requires new payment",
    newSearchPaymentCopy: "Each vehicle check is a one-time £1 payment that unlocks all premium analyses for that car.",
    checkNewCarForOnePound: "Check new car for £1.00",
    vinInvalidLength: "VIN must be exactly 17 characters",
    vinInvalidChars: "VIN can only contain letters and numbers",
    addVinBadge: "Free upgrade",
    addVinTitle: "Verify VIN matches the registration",
    addVinCopy: "Spot cloned cars and VIN-swap scams in seconds. We compare your VIN against DVLA make and year — instant, free, no extra payment.",
    addVinCta: "Add VIN now",
    shareWithMechanicBadge: "Second opinion",
    shareWithMechanicTitle: "Share this report with your mechanic",
    shareWithMechanicCopy: "Send the registration to a trusted mechanic or friend. They'll get a one-tap link to verify the findings before you commit.",
    shareWithMechanicCta: "Share link",
    shareWithMechanicMessage: "Hey — what do you think of this car? Worthify analysed it for me:",
    shareWithMechanicCopied: "Link copied — paste it to your mechanic",
    shareWithMechanicCopyError: "Couldn't copy. Long-press to share manually.",
    marketGauge_UNDERPRICED: "Underpriced",
    marketGauge_FAIR: "Fair value",
    marketGauge_SLIGHTLY_OVER: "Slightly overpriced",
    marketGauge_SIGNIFICANTLY_OVER: "Significantly overpriced",
    marketGaugeAskingLabel: "Asking",
    marketGaugeMarketLabel: "Market",
    recurringIgnoredBadge: "Ignored multiple cycles",
    recurringIssuesTimelineTitle: "Recurring issues timeline",
    negotiationHeadline: "Negotiation target",
    negotiationItemTarget: "Suggested ask",
    negotiationCumulativeLabel: "Cumulative buyer saving",
    betaDataBannerTitle: "Beta data — full version coming soon",
    betaDataBannerBody: "This module currently uses heuristic estimates based on the vehicle profile. Real-data integration ships in the next release.",
    addVinBadgeLowConf: "Improve accuracy",
    addVinTitleLowConf: "Add VIN for a tighter valuation",
    addVinCopyLowConf: "This is a newer / niche model — public price data is thin. Adding the VIN lets us pin down the exact trim, model-year list price and real residual value.",
    addVinModalTitle: "Verify VIN",
    addVinModalCopy: "Enter the 17-character VIN from the seller (V5C log book or windscreen plate). We'll check it against DVLA make and year — if it doesn't match, your score is forced to AVOID.",
    addVinSubmit: "Verify VIN now",
    addVinChecking: "Checking VIN…",
    addVinDone: "Done",
    addVinError: "Failed to verify VIN. Please try again.",
    addVinScamTitle: "VIN mismatch detected — possible cloned car",
    addVinScamCopy: "Score has been forced to AVOID. See the red banner on your dashboard.",
    addVinOkTitle: "VIN verified — make and year match",
    addVinOkCopy: "No cloning signal. Your dashboard now shows the verified badge.",
    addVinUndecodableTitle: "VIN saved — couldn't decode publicly",
    addVinUndecodableCopy: "The US public database doesn't list this VIN. Common for UK-only models — not a red flag on its own.",
    vinUndecodableNote: "Your VIN is recorded but couldn't be decoded by the public US database. Many UK-only models aren't listed there — this is not a red flag on its own.",
    vinVerifiedBadge: "VIN verified",
    vinVerifiedCopy: "Seller's VIN matches DVLA make and year. No cloning signal detected.",
    // ─── Legal pages ─────────────────────────────────────────────────
    legalNavTerms: "Terms of Service",
    legalNavPrivacy: "Privacy Policy",
    legalNavCookies: "Cookie Policy",
    legalNavAccessibility: "Accessibility",
    legalBackToHome: "Back to Worthify",
    legalLastUpdated: "Last updated",
    legalAllRights: "All rights reserved.",
    // ─── Trust strip & methodology ───────────────────────────────────
    trustVerifiedBy: "Verified by",
    trustJustNow: "just now",
    trustMinutesAgo: "{n} min ago",
    trustHoursAgo: "{n} hr ago",
    trustDaysAgo: "{n} day ago",
    trustAisAgreed: "AIs agreed",
    trustHowItWorks: "How it works",
    methodologyTitle: "How Worthify works",
    methodologyIntro: "Worthify combines public UK government data with a 3-model AI consensus to estimate the risk of buying a specific used car. Here is exactly where each piece of information comes from.",
    methodologySourcesTitle: "Data sources",
    sourceDvsaDesc: "Official UK government — every MOT test result, advisories and dangerous defects.",
    sourceNhtsaDesc: "Public US government database used to decode the seller's VIN and detect cloned-car scams.",
    sourceAiDesc: "Three independent large language models analyse the data in parallel. The Worthify Score uses the median of their estimates so a single hallucination cannot skew the result.",
    methodologyConfidence: "Confidence: {level}",
    confidenceHigh: "High",
    confidenceMedium: "Medium",
    confidenceLow: "Low",
    methodologyConfHighHint: "MOT history, VIN and mileage all present — multi-AI agreement on results.",
    methodologyConfMedHint: "Some data points missing (e.g. VIN or full MOT). Score is reliable but not maximal.",
    methodologyConfLowHint: "Limited public data for this vehicle. Score is a heuristic — physical inspection strongly recommended.",
    methodologyDisclaimerTitle: "Independent inspection still recommended",
    methodologyDisclaimer: "Worthify aggregates official DVSA, DVLA and NHTSA data with a 3-AI consensus engine — true More Than HPI Check coverage at a fraction of the price. It does not replace a physical inspection. Always book your own mechanical check before buying.",
    dashboardAiDisclaimer: "This is not a mechanical inspection. Always carry out your own mechanical check before buying.",
    // ─── Pre-checkout consent modal (UK Consumer Contracts Regs 2013) ─
    preCheckoutBadge: "Confirm purchase",
    preCheckoutVerdictProductName: "Worthify Basic Verdict",
    preCheckoutPdfProductName: "Premium Worthify Report (PDF + 15 modules)",
    preCheckoutTotal: "Total",
    preCheckoutOneTime: "One-time payment",
    preCheckoutNoSub: "No subscription · No auto-renewal",
    preCheckoutWarningTitle: "Instant digital delivery",
    preCheckoutWarningBody: "Your report is delivered immediately in your browser the moment payment succeeds. By confirming, you agree to start performance now and waive your 14-day cancellation right under the UK Consumer Contracts Regulations 2013.",
    preCheckoutConsent: "I agree to instant delivery and understand I lose my 14-day cancellation right.",
    preCheckoutPayCta: "Pay £{n} with Stripe",
    preCheckoutRedirecting: "Redirecting to Stripe…",
    preCheckoutTrustLine: "Secured by Stripe · Card details never touch Worthify · Receipt sent automatically",
    paymentTimeoutError: "Payment is taking longer than usual. If you were charged, please contact support@worthify.co.uk quoting session ID: ",
    premiumAnalysesBadge: "Premium analyses",
    ownersModalTitle: "Previous owners",
    ownerSingular: "registered owner",
    ownerPlural: "registered owners",
    ownersTimelineTitle: "Ownership timeline",
    ownerLabel: "Owner",
    ownersInsightTitle: "Ownership insight",
    ownersFewCopy: "Few owners — usually means the car was well looked after.",
    ownersAverageCopy: "Average ownership — no red flags, but ask for service records.",
    ownersManyCopy: "Many owners in a short period can signal problems — investigate carefully.",
    ownersCountLabel: "Total owners",
    lastChangeLabel: "Last change",
    accidentModalTitle: "Accident history",
    accidentRiskHigh: "Potential damage history",
    accidentRiskLow: "No accident flags",
    accidentScopeLabel: "Based on MOT structural checks",
    accidentChecksTitle: "What we checked",
    accidentCheck1: "Chassis / structural defects in MOT history",
    accidentCheck2: "Steering & suspension alignment failures",
    accidentCheck3: "Major body repair notes across test centres",
    accidentCheck4: "Cross-referenced with industry accident registers",
    structuralFlagsLabel: "Structural flags",
    damageHistoryLabel: "Damage history",
    writeOffModalTitle: "Write-off check",
    writeOffFlagged: "Review required",
    writeOffClean: "No write-off record",
    writeOffScope: "Cat S · Cat N · Cat A · Cat B",
    writeOffCategoriesTitle: "Category check",
    writeOffCatA: "Scrap only",
    writeOffCatB: "Break for parts",
    writeOffCatS: "Structural damage",
    writeOffCatN: "Non-structural",
    financeModalTitle: "Outstanding finance",
    financeFound: "Outstanding finance",
    financeClean: "No outstanding finance",
    financeFoundCopy: "This vehicle has active finance — it cannot be legally sold until settled. Walk away until the seller shows settlement proof.",
    financeCleanCopy: "No active loan, lease or HP agreement detected against this vehicle. You're safe to proceed.",
    financeContextTitle: "Context",
    financeContextCopy: "At a valuation around {value}, cars with outstanding finance are involved in ~5% of UK private-sale disputes. This vehicle is clear.",
    financeStatusLabel: "Finance status",
    premiumAnalysesLocked: "premium analyses locked",
    // ─── ULEZ / Clean Air ───
    ulezModalTitle: "ULEZ / Clean Air",
    ulezStatusLabel: "ULEZ status",
    euroClassLabel: "Euro class",
    ulezCompliantTitle: "ULEZ compliant",
    ulezNonCompliantTitle: "Not ULEZ compliant",
    ulezChargesTitle: "Daily charge in UK zones",
    govUkDisclaimer: "Estimated based on year & fuel. Confirm at gov.uk/check-clean-air-zone-charge",
    // ─── Running costs ───
    runningCostsModalTitle: "Running costs",
    annualCostLabel: "Annual total",
    monthlyCostLabel: "Per month",
    perYear: "per year",
    perMonth: "per month",
    assumedMiles: "assumed 10k mi/year",
    costBreakdownTitle: "Breakdown",
    costFuel: "Fuel",
    costTax: "Road tax",
    costInsurance: "Insurance",
    costService: "Service",
    runningCostsDisclaimer: "Estimates based on UK averages. Actual costs vary by driving style, location and insurer.",
    // ─── Depreciation ───
    depreciationModalTitle: "Depreciation forecast",
    valueIn3Label: "Value in 3y",
    valueIn5Label: "Value in 5y",
    currentValueLabel: "Current value",
    nowLabel: "Now",
    forecastTableTitle: "Forecast",
    inLabel: "In",
    yearLabel: "year",
    yearsLabel: "years",
    // ─── Theft ───
    theftModalTitle: "Theft & stolen check",
    policeRegisterLabel: "Police register",
    dvlaRecordLabel: "DVLA record",
    theftFlagged: "Reported stolen",
    theftClean: "No theft record",
    theftFlaggedCopy: "This vehicle is registered as stolen. Do NOT proceed — contact police on 101.",
    theftCleanCopy: "No entry found on the Police National Computer or DVLA stolen register. This vehicle appears legitimate.",
    theftChecksTitle: "Registers checked",
    theftCheck1: "Police National Computer (PNC)",
    theftCheck2: "DVLA stolen register",
    theftCheck3: "MIAFTR (insurance industry)",
    theftCheck4: "Ports / import red flags",
    // ─── Import ───
    importModalTitle: "Import history",
    originLabel: "Origin",
    importTypeLabel: "Import type",
    importDetected: "Import detected",
    noImportFlag: "UK / EU market",
    fromCountryLabel: "Country",
    typeLabel: "Type",
    importImpactTitle: "What this means",
    importImpactCopy: "Imported cars can be harder to insure and may have slower parts availability. Check the V5C for the date of UK registration and any NOVA (Notification of Vehicle Arrival) certificate.",
    noVinForImport: "Add a VIN on the landing page for a full country-of-origin check.",
    // ─── Insurance group ───
    insuranceGroupModalTitle: "Insurance group",
    abiGroupLabel: "ABI group",
    premiumRangeLabel: "Typical premium",
    outOfLabel: "out of",
    premiumEstimateTitle: "Annual premium estimate",
    perYearLabel: "per year",
    basedOn30yoLabel: "30-year-old driver, 5 years no-claims",
    insuranceDisclaimer: "Estimated group. Your actual premium depends on age, postcode, claims history and excess.",
    // ─── Tyre & brake ───
    tyreBrakeModalTitle: "Tyre & brake wear",
    tyresLabel: "Tyres",
    brakesLabel: "Brakes",
    lifeRemaining: "life remaining",
    wearWarningTitle: "Budget for replacement",
    wearBothCopy: "MOT history shows repeated tyre AND brake defects. Budget £600+ for replacement in the first 6 months.",
    wearTyreCopy: "MOT history flags tyre wear. Budget £300-500 for a set of 4 tyres.",
    wearBrakeCopy: "MOT history flags brake wear. Budget £200-400 for pads/discs replacement.",
    // ─── Similar sold ───
    similarSoldModalTitle: "Similar sold cars",
    averageSoldLabel: "Avg sold price",
    avgDaysLabel: "Avg days to sell",
    basedOnLastNSales: "Based on last 5 comparable sales",
    avgDaysOnMarket: "avg days on market",
    recentSalesTitle: "Recent comparable sales",
    daysToSell: "days to sell",
    similarSoldDisclaimer: "Prices sampled from UK classifieds for the same make/model and year range.",
    helpHeroKicker: "3 Independent experts",
    helpHeroTitle: "Scoring this vehicle's history for you",
    helpUnlockHero: "Unlock the full picture",
    helpUnlockSub: "Engine · Negotiation · Anomalies · Finance · PDF",
    helpDownloadHero: "Download your full report",
    helpDownloadSub: "Premium analyses + PDF — already paid",
    // ─── WhatYouGet trust modal (pre-Stripe) ───
    whatYouGetTitle: "What you'll get",
    whatYouGetKicker: "Premium unlock — £4.99",
    whatYouGetHeadline: "15 premium analyses + full PDF",
    socialProofCopy: "Used by 50,000+ UK car buyers",
    includedTitle: "Everything that's included",
    benefitEngine: "Engine analysis & known issues",
    benefitNegotiation: "Negotiation power tactics",
    benefitAccident: "Accident & write-off check",
    benefitFinance: "Outstanding finance check",
    benefitUlez: "ULEZ + 5-year running costs",
    benefitDepreciation: "Depreciation forecast",
    benefitSimilar: "Similar sold cars (last 5)",
    benefitPdf: "Full printable PDF report",
    trustSecure: "Stripe secured",
    trustInstant: "Instant access",
    trustGdpr: "GDPR compliant",
    proceedToPaymentCta: "Continue to payment — £4.99",
    maybeLaterCta: "Maybe later",
    // ─── Premium Home view + nav ───
    navPremium: "Premium",
    premiumHomeKicker: "Premium · Unlocked",
    premiumHomeTitle: "All 15 premium analyses",
    premiumHomeCopy: "Tap any tile to dive into the full analysis. Tap Overview to return to the main dashboard.",
    premiumHomeFooter: "Tap Overview below to return to the main dashboard",
    premiumLabel: "Premium",
    independentBadge: "Independent",
    helpModalTitle: "How Worthify works",
    helpSection1Title: "Your verdict",
    helpSection1Copy: "The hero card shows the verdict based on 3 independent experts scoring this vehicle's history.",
    helpSection2Title: "Explore each tile",
    helpSection2Copy: "Tap any tile to open the full modal with details, graphics and expert tips. Swipe left/right to move between modals.",
    helpSection3Title: "Unlock everything",
    helpSection3Copy: "A single £4.99 payment unlocks engine analysis, negotiation power, anomaly check, hidden finance risk and the full printable PDF report.",
    engineAnalysisShort: "Engine issues",
    viewEngine: "View engine",
    negotiationShort: "Leverage",
    viewNegotiation: "Negotiate",
    anomaliesShort: "Anomalies",
    viewAnomalies: "View anomalies",
    navExpertise: "Expertise",

    // Dashboard – additional labels (DVLA / V5C / ULEZ / Expert findings)
    motExpiryLabel: "MOT expires",
    v5cIssuedLabel: "Last V5C",
    seeFullExpertAnalysis: "See full expert analysis",
    confidenceLabelHigh: "High confidence",
    confidenceLabelMedium: "Medium confidence",
    confidenceLabelLow: "Low confidence",
    leverageLabel: "Leverage",
    rangeLabel: "range",
    marketGaugeVsMarket: "vs market",
    severityDangerous: "Dangerous",
    severityFailure: "Failure",
    severityMajor: "Major",
    severityMinor: "Minor",
    severityAdvisory: "Advisory",
    severityNote: "Note",
    recurringAcross: "across",
    recurringYearsLabel: "years",
    yearSingular: "year",
    yearPlural: "years",
    copyNegotiationCta: "Copy negotiation arguments",
    copyNegotiationAria: "Copy negotiation arguments to clipboard",
    copyNegoTitle: "Worthify – negotiation arguments",
    copyNegoTotalLabel: "Total target",
    copyNegoRangeLabel: "Range",
    copyNegoSourceLabel: "Source",
    copyNegoSuccess: "Arguments copied — paste into WhatsApp or SMS",
    copyNegoError: "Copy failed — try again",

    // Simple Explanation modal (plain-language summary for all tiers)
    simpleExplanationTitle: "Plain English summary",
    simpleExplanationKicker: "Plain English",
    simpleExplanationHeadline: "Should I buy this?",
    simpleExplanationSubhead: "A no-jargon answer based on the full Worthify analysis — written so anyone can understand it.",
    simpleExplanationVerdictTitle: "Here's the deal",
    simpleExplanationEmpty: "Analysis is still being prepared. Try again in a moment.",
    simpleExplanationDisclaimer: "This summary is for guidance only — always have a qualified mechanic inspect the car in person before buying.",
    simpleExplanationCardTitle: "Should I buy this?",
    simpleExplanationCardSub: "A 60-second answer anyone can understand",
    simpleExplanationLockedTitle: "Full breakdown",
    simpleExplanationLockedBadge: "Locked — unlock with Premium",
    simpleExplanationUnlockCta: "Unlock full explanation — Premium",
    unlockItemSimpleExplanation: "Plain-English buy/avoid summary",

    // MOT defect theme labels (used by Top Risk / Detected Issues lists)
    defectThemeOilLeak: "Engine oil leak / seal weeping",
    defectThemeBrakes: "Brake component wear",
    defectThemeTyres: "Tyre wear / condition",
    defectThemeSteering: "Steering / suspension joint wear",
    defectThemeSuspension: "Suspension component wear",
    defectThemeEmissions: "Emissions system issue",
    defectThemeLights: "Lighting fault",
    defectThemeExhaust: "Exhaust system wear",
    defectThemeElectrical: "Electrical / charging issue",
    defectThemeCorrosion: "Corrosion / structural wear",
    defectThemeWipers: "Wipers / washers",
    defectThemeSeatbelt: "Seatbelt / restraint check",
    defectThemeScreen: "Windscreen / glass",
    defectRecurringSuffix: "Recurring in MOT — not fixed, may worsen over time.",
    expertsCountBadge: "3 experts",
    expertiseLockedMore: "more in Premium",
    expertDeepAnalysisTitle: "Each expert's findings",
    expertNoFindings: "No specific findings flagged by this expert.",
    co2Label: "CO₂",
    dataSourceDvla: "Source: DVLA VES",
    vehicleCo2Label: "CO₂ emissions",
    vehicleEuroLabel: "Euro class",
    vehicleTypeApprovalLabel: "Type approval",
    vehicleUlezLabel: "ULEZ",
    vehicleV5CLabel: "Last V5C",
    vehicleMarkedForExportLabel: "Marked for export",
    ulezCompliantShort: "Compliant",
    ulezNonCompliantShort: "Charged",
    ulezVerifyShort: "Verify on TfL",
    ulezVerifyOnTfl: "Verify on TfL — official checker",
    ulezUnknownTitle: "ULEZ status not confirmed",
    ulezUnknownNote: "DVLA hasn't returned the Euro emissions class for this plate. Older diesels can be retrofitted, and cherished plates can mask a newer Euro 6 vehicle — verify with TfL's official checker below.",
    ownersV5CLabel: "Last V5C issued",
    ownersV5CFreshNote: "Issued within the last 12 months — typically indicates a recent ownership change (DVLA).",
    ownersV5COldNote: "Same V5C document still active — no recent registered transfer.",
    riskLevel_HIGH: "HIGH",
    riskLevel_MEDIUM: "MEDIUM",
    riskLevel_LOW: "LOW",
    errorInvalidPlateChars: "Only letters and numbers allowed in UK plates.",
    legalEnNotice: "This legal document is provided in English. The Worthify Service is operated from the United Kingdom and UK law applies. Contact support@worthify.co.uk for clarification.",
    ninaButtonLabel: "Ask Nina — Powered by Pine",
    ninaHeaderTitle: "Nina — Your Car Buying Co-Pilot",
    poweredByPine: "Powered by Pine",
    ninaGreeting: "Hi! I've read your vehicle report for {reg}. Want to know if this car is worth buying? Just ask me anything.",
    ninaGreetingWorthifyAsk: "Hi! I've checked the report for {reg}. Based on Worthify's value, you could negotiate the price down by {saving} — from {asking} to {target}. Want me to handle the call for you? Tap Call below.",
    ninaGreetingWorthifyMarket: "Hi! I've checked the report for {reg}. Based on Worthify's value, you could negotiate the price down to around {target} ({saving} below market). Want me to handle the call for you? Tap Call below.",
    ninaInputPlaceholder: "Ask Nina anything…",
    ninaCallPitch: "Want me to call the seller and negotiate the price?",
    ninaCallSellerCta: "Call Seller Now — £2.99",
    ninaCalling: "Nina is calling the seller…",
    ninaCallDone: "Call complete",
    ninaCallFailed: "Call failed",
    ninaCallFailedHint: "The seller didn't pick up or the call couldn't connect. You haven't been charged.",
    ninaCallTimeout: "Call timed out — please try again.",
    backGuardToast: "Swipe back again to leave this report",
    heroVehicleTypes: "Cars · Motorcycles · Vans · Trucks — any UK registration",
    vehicleCategoryMotorcycle: "Motorcycle",
    ninaCounterOfferTitle: "Seller's counter-offer",
    ninaCounterOfferBody: "Nina told the seller you'd think it over — the deal is still on the table. Accept and Nina will call back to confirm, or reject it.",
    ninaCounterAboveMax: "{diff} above your max budget",
    ninaCounterAcceptCta: "Accept {price} — Nina confirms",
    ninaCounterRejectCta: "Reject counter-offer",
    ninaRecalling: "Nina is calling the seller back to confirm the deal…",
    ninaCounterRejectedMsg: "Got it — I rejected the counter-offer. The seller knows you're walking away unless the price improves. You can keep asking me anything.",
    ninaCallTranscriptToggle: "View transcript",
    ninaCallMockSummary: "Seller agreed to consider £5,700 (down from £6,000). Asked you to call back this evening to confirm.",
    // Seller details modal (Etap 3)
    ninaCallSellerTitle: "Nina calls the seller",
    ninaCallSellerSubtitle: "Nina will phone the seller, negotiate based on your report's leverage, and send you a full transcript. £2.99 one-time.",
    ninaSellerNameLabel: "Seller's name (if known)",
    ninaSellerNamePlaceholder: "e.g. James",
    ninaSellerPhoneLabel: "Seller's UK phone *",
    ninaInvalidPhone: "Enter a valid UK number (e.g. 07xxx xxxxxx)",
    ninaTargetPriceLabel: "Target £",
    ninaMaxPriceLabel: "Max £",
    ninaAnchorAsking: "asking price",
    ninaAnchorMarket: "market value",
    ninaTargetHint: "💡 Suggested {amt} · {pct}% below {anchor}",
    ninaTargetHintAt: "💡 Suggested {amt} · matches {anchor}",
    ninaMaxHint: "🛑 Walk-away {amt} · {pct}% below {anchor}",
    ninaMaxHintAbove: "🛑 Walk-away {amt} · {pct}% above {anchor}",
    ninaWorthifySuggestionKicker: "Worthify suggests",
    ninaWorthifyDelta: "{pct}% below {anchor}",
    ninaWorthifyRationale: "Based on documented MOT issues, repair-cost estimates and market data. Highest chance of a successful negotiation.",
    ninaMaxBudgetLabel: "Your max budget £",
    ninaBudgetHelper: "Setting a HIGHER budget than suggested increases the chance of a successful negotiation. Setting a LOWER budget reduces the chance — but keeps you in your means.",
    ninaBudgetMatch: "🎯 Matches Worthify — highest chance of a successful negotiation.",
    ninaBudgetAbove: "✅ Above Worthify — Nina opens at {wfy}, walks up to your {max} only if the seller refuses. High chance of success.",
    ninaBudgetBelow: "⚠️ Below Worthify — Nina opens at your {max}, walks up to {wfy} only as a last resort. Lower chance, but stays in your budget.",
    ninaCallNowSingleCta: "Pay £2.99 · Call & negotiate at {amt}",
    ninaCallNowRangeCta: "Pay £2.99 · Call · {tgt} → {max}",
    ninaCallLegalNote: "By proceeding you confirm you have lawful basis to contact this number. The call will be recorded and transcribed by Pine.",
    ninaPayAndCallCta: "Pay £2.99 & start the call",
    ninaCheckoutFailed: "Couldn't start checkout. Please try again.",
    // Negotiation outcome card (Etap 4)
    ninaDealAgreed: "Deal agreed!",
    ninaWasAsking: "Was asking",
    ninaAgreedAt: "Agreed at",
    ninaSavedYou: "You saved",
    ninaSellerSaid: "Seller said",
    ninaNoAnswer: "No answer",
    ninaNoDeal: "No deal reached",
    ninaDealPdfDownload: "Save deal as PDF",
    ninaDealPdfPreparing: "Preparing your PDF…",
    ninaDealEmailToggle: "Email PDF",
    ninaDealEmailPlaceholder: "your@email.com",
    ninaDealEmailSend: "Send",
    ninaDealEmailSending: "Sending…",
    ninaDealEmailSent: "Sent",
    priceNoAskingLabel: "Add asking price",
    priceNoAskingHeadline: "Enter the seller's asking price for an instant verdict.",
    priceNoAskingSub: "Without it we can show you the market range below, but we can't tell you if it's a fair deal, overpriced, or a scam.",
    priceNoAskingCta: "Get verdict",
    priceAskingPlaceholder: "e.g. £6,500",
    priceAskingHintMedian: "e.g.",
    ninaToastPaid: "Payment confirmed",
    ninaToastCallingNamed: "Nina is now calling {name}…",
    ninaToastCallingGeneric: "Nina is now calling the seller…",
    ninaToastInProgress: "Nina is on the call",
    ninaToastNegotiatingNamed: "Negotiating with {name} now…",
    ninaToastNegotiatingGeneric: "Negotiating with the seller now…",
    ninaToastDealHeadline: "Deal agreed!",
    ninaToastSavedYou: "You saved £{amount}",
    ninaToastCallComplete: "Call complete",
    ninaToastCallCompleteSub: "Open Nina for the full transcript.",
    ninaToastCallFailed: "Call could not connect",
    // Share win toast button
    ninaShareWinCta: "Share win",
    ninaShareWinTitle: "I saved £{amount} with Worthify",
    ninaShareWinText: "I just saved £{amount} on a used car with Worthify Nina 📞 — the AI co-pilot that calls the seller and negotiates for you.",
    // Share with mechanic
    shareMechanicTitle: "Send to your mechanic",
    shareMechanicSubtitle: "Get a second opinion before you buy. The full report opens read-only — no payment needed for them.",
    shareMechanicMessage: "Can you take a quick look at this car report before I buy? It's a {vehicle} ({reg}). Independent MOT + AI analysis from Worthify:",
    shareMechanicEmailSubject: "Worthify report for {reg}",
    shareMechanicEmail: "Email",
    shareMechanicCopy: "Copy link",
    shareMechanicCopied: "Copied!",
    shareMechanicMoreOptions: "More share options",
    // Camera OCR (scan plate / VIN)
    scanPlateAria: "Scan plate with camera",
    scanVinAria: "Scan VIN with camera",
    scanPlateNotFound: "No plate detected. Try a closer, well-lit shot.",
    scanVinNotFound: "No VIN detected. Try a closer, well-lit shot.",
    scanGenericError: "Couldn't read the image. Try again.",
    // First-run camera tutorial
    scanTutorialPlateTitle: "Get the perfect plate shot",
    scanTutorialPlateSubtitle: "Three quick tips for instant detection.",
    scanTutorialVinTitle: "Get the perfect VIN shot",
    scanTutorialVinSubtitle: "VINs are small — keep the camera steady.",
    scanTipCenter: "Centre the plate in the frame",
    scanTipLight: "Make sure it's well-lit (no shadows)",
    scanTipClose: "Get close — the plate should fill most of the photo",
    scanTipVinLocation: "VIN is on the dashboard (visible through the windscreen) or door jamb",
    scanTipVinClose: "Get close — the 17 characters should fill most of the photo",
    scanTutorialCta: "Got it — open camera",
    scanTutorialSkip: "Cancel",

    // ── Disability-friendly add-on (Session H15) ──
    disabilityBadge: "DISABILITY FRIENDLY",
    ninaAutoCallTitle: "Autonomous Call for You",
    ninaAutoCallPoweredBy: "powered by Pine.ai",
    ninaAutoCallDesc: "Worthify makes the negotiation call on your behalf to get the best deal possible, so you don't have to worry about anything — ideal for users who are deaf, non-verbal, or have difficulty communicating over the phone.",
    ninaAutoCallPerCall: "per call",
    heroDisabilityBadge: "Disability-friendly app — we help those who need it most",

    // ── Premium real registry data (Vehicle Data Global) ──
    gvdSourceNote: "Live DVLA registry data",
    accidentSourceNote: "Live data from MIAFTR + DVLA vehicle history",
    miaftrSourceNote: "Live data from MIAFTR (Motor Insurers Anti-Fraud Register)",
    financeSourceNote: "Live data from HPI / Experian finance register",
    ownersKeeperLabel: "Keeper",
    ownersSinceLabel: "since",
    registryChecksTitle: "DVLA registry checks",
    importedFlagLabel: "Imported",
    importOutsideEuLabel: "Imported outside EU",
    importExportedLabel: "Exported",
    importScrappedLabel: "Scrapped",
    ukSuppliedLabel: "UK supplied",
    flaggedLabel: "Flagged",
    notFlaggedLabel: "Not flagged",
    liveValuationTitle: "Live market valuation",
    valDealerForecourt: "Dealer forecourt",
    valPrivateClean: "Private sale (clean)",
    valPartExchange: "Part exchange",
    valAuction: "Auction",
    valMileageNote: "Valued at {miles} miles · live industry data",
    tyreFitmentTitle: "Factory tyre fitment",
    tyreFrontLabel: "Front",
    tyreRearLabel: "Rear",
    priceEvalLabel: "Price Check",
    mileageTileLabel: "Mileage",
    dvlaSubtitle: "Driver and Vehicle Licensing Agency",
    dvsaSubtitle: "Driver & Vehicle Standards Agency",
    dvsaOfficialData: "Official MOT data",
    poweredBy: "Powered by",
    gvdSubtitle: "Commercial vehicle data partner",
    hpiSubtitle: "More data than a standard HPI check",
    errorInvalidRegistration: "That registration doesn't look right — please check the plate and try again.",

};
